import { useQuery, UseQueryResult } from 'react-query';
import makeDrivers from 'infrastructure/drivers/json';
import { Method } from '@ux/drivers';
import { useDSTActionContext, DSTActionState } from 'presentation/components/pages/CMPage/DSTContext';

const drivers = makeDrivers();

const checkDomainAvailability = (setQuery: DSTActionState, domainName?: string) => {
  if (domainName != null) {
    setQuery({ type: 'DISABLE_CTA_BUTTONS' });
    return drivers({
      url: `/api/dst/v0/isFqdnAvailable?fqdn=${domainName}`,
      method: Method.GET,
    });
  }
};

export default function useCheckDomainAvailability(domainName?: string): UseQueryResult<boolean> {
  const setQuery = useDSTActionContext();
  return useQuery(['@usf/checkDomainAvailability', domainName], () => checkDomainAvailability(setQuery, domainName), {
    enabled: false,
    refetchOnWindowFocus: false,
    onSettled: () => {
      setQuery({ type: 'ENABLE_CTA_BUTTONS' });
    },
  });
}

export function useCheckMultiDomainAvailability(domains: Array<string>) {
  const setQuery = useDSTActionContext();

  const checkBundleAvailability = () => {
    // Create promises to check availability of each domain in list
    const promises: Array<Promise<boolean> | undefined> = domains.map((domain) =>
      checkDomainAvailability(setQuery, domain),
    );
    return Promise.all(promises);
  };

  return useQuery(['@usf/checkMultiDomainAvailability', domains], checkBundleAvailability, {
    enabled: false,
    refetchOnWindowFocus: false,
    onSettled: () => {
      setQuery({ type: 'ENABLE_CTA_BUTTONS' });
    },
  });
}
